// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__kPWiB","description":"style_description__Zv81d","logo":"style_logo__kXFcT","title":"style_title__jq0Js"};